module.exports = __webpack_public_path__ + "img/C03TechVeteranWarship_ua.72906a18.webp";